import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { gaTrack } from "@/lib/analytics";

/* ------------------------------------------------------------------ */
/*  Sticky "Get started" bar for public content pages (About, Blog,    */
/*  Contact). Pinned to the bottom of the viewport so the ask stays in */
/*  reach while a visitor browses. Routes through the /get-started      */
/*  teaser (business by default; audience="talent" for the /for-talent */
/*  world). Renders its own spacer so page content never hides behind  */
/*  the bar. Matches the inline sticky bars on the landing pages.       */
/* ------------------------------------------------------------------ */
export default function GetStartedBar({
  audience = "business",
  message = "Ready to put your workforce in one place?",
  sub = "Free to join. Set up in under two minutes.",
  location = "content_sticky_bar",
}) {
  /* Business went to a bare /get-started, which is the audience chooser, so
     the bar on a business page asked people to pick the side they were already
     reading about. Both sides now name their audience. Business lands on the
     doors: pressing "Get started" says nothing about whether they want to write
     a post or just open an account, so the next screen asks. */
  const to = audience === "talent"
    ? "/get-started?a=talent"
    : "/get-started?a=business&c=1";
  const accountType = audience === "talent" ? "individual" : "organization";

  return (
    <>
      {/* Spacer so the closing content clears the fixed bar. */}
      <div aria-hidden="true" style={{ height: 84 }} />

      <div
        role="complementary"
        aria-label="Get started with Sift"
        style={{
          position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 40,
          background: "rgba(250,248,242,.9)", backdropFilter: "saturate(180%) blur(12px)", WebkitBackdropFilter: "saturate(180%) blur(12px)",
          borderTop: "1px solid var(--border)", padding: "12px 24px calc(12px + env(safe-area-inset-bottom))",
          boxShadow: "0 -8px 30px -18px rgba(27,24,19,.4)", fontFamily: "var(--font-sans)",
        }}
      >
        <div style={{ maxWidth: 1080, margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontWeight: 600, fontSize: "0.9375rem", color: "var(--ink)" }}>{message}</div>
            <div className="gsb-sub" style={{ fontWeight: 400, fontSize: "0.8125rem", color: "var(--text-secondary)" }}>{sub}</div>
          </div>
          <Link
            to={to}
            onClick={() => gaTrack("cta_get_started", { location, account_type: accountType })}
            style={{
              flex: "0 0 auto", display: "inline-flex", alignItems: "center", gap: 8, background: "var(--brand)", color: "#fff",
              padding: "13px 30px", borderRadius: "var(--r-pill)", fontWeight: 700, fontSize: "0.96875rem", boxShadow: "var(--shadow-md)", whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "var(--brand-hover)")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "var(--brand)")}
          >
            Get started <ArrowRight size={18} strokeWidth={2.4} aria-hidden="true" />
          </Link>
        </div>
        {/* Hide the subline on very narrow screens. */}
        <style>{`@media (max-width:560px){ .gsb-sub{ display:none; } }`}</style>
      </div>
    </>
  );
}
